import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding: 16px;
  min-height: 150px;
  border-radius: 3px;
  width: 100%;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  background-color: #fff;
  background-clip: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  
  @media (min-width: 1025px) {
    min-height: 31.6%;
    min-width: 320px;
  }

  .number_charged {
    font-size: 30px;
    justify-self: center;
    color: #3a89ff;
    margin-left: 10px;
    font-weight: 600;
  }

  .description_charged {
    font-size: 18px;
    color: #3a89ff;
    margin: 0;
    padding-left: 8px;
  }

  .number_registered {
    font-size: 30px;
    justify-self: flex-end;
    color: #007c0c;
    margin-left: 8px;
    font-weight: 600;
  }

  .description_registered_wrapper {
    padding-top: 8px;
    display: flex;
    align-items: center;
  }

  .description_registered {
    font-size: 13px;
    margin: 0;
    padding-left: 4px;
    
    @media (min-width: 1280px) {
      padding-left: 8px;
    }
  }

  .indicators--icon {
    font-size: 40px;
  }

  .indicators--chargeicon {
    svg {
      width: 40px;
      height: 40px;
    }
  }

  .number_charged--energy {
    font-size: 25px;
    justify-self: center;
    color: #3a89ff;
    margin-left: 0;
    font-weight: 600;
    position: relative;
    z-index: 1;
  }
  .number_charged--energy-countup {
    font-size: 25px;
    justify-self: center;
    color: #EA4235;
    margin-left: 0;
    font-weight: 600;
    position: relative;
    z-index: 1;
  }
  .number_charged--energy-value {
    font-size: 25px;
    justify-self: center;
    color: #1CAF9A;
    margin-left: 0;
    font-weight: 600;
    position: relative;
    z-index: 1;
  }
  .description_charged {
    font-size: 18px;
    color: #3a89ff;
    margin: 0;
    padding-left: 8px;
  }
  .description_registered--portrait {
    font-size: 13px;
    margin: 0;
    padding-left: 8px;
  }
`;

export const Title = styled.h3`
  font-size: 13px;
  margin-bottom: 8px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  font-family: 'Roboto', sans-serif;

`;

export const SubWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
`;


export const Indicator = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  position: relative;
  justify-content: center;
`;

export const IndicatorValues = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  margin-bottom: 4px;
`;

export const IndicatorLabels = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
